import {Button, Center, Loader, Space, Text, TextInput} from "@mantine/core";
import { Contact } from "../types/Contact";
import { closeAllModals, openModal } from "@mantine/modals";
import React, { FC, useState } from "react";
import { useForm } from "@mantine/form";
import { isDefined } from "../Utils/utils";
import { ContactS } from "../Service/restapi/contactService";

interface Props {
  contact: Contact;
  profileId: number;
  documentType: 'CONTRACT' | 'OFFER';
  onFinish: (contact: Contact) => unknown;
}

export const openCustomerAddressModal = (props: Props) =>
  openModal({
    title: (
      <Text weight="bolder" size="xl">
          {props.documentType == 'CONTRACT' ? 'Vertrag' : 'Angebot'} bestätigen
      </Text>
    ),
    children: <CustomerAddressModal {...props} />,
  });

const CustomerAddressModal: FC<Props> = ({ contact, onFinish, profileId, documentType }) => {
  const { id, addressStreetAndNo, zipCode, city, phoneNumber, partner } = contact;
  const [loading, setLoading] = useState(false);

  const form = useForm({
    initialValues: { addressStreetAndNo, zipCode, city, phoneNumber, partnerFirstName : partner?.firstName, partnerLastName : partner?.lastName },
    validate: {
      addressStreetAndNo: (val: string) =>
        isDefined(val) ? null : "Bitte Wert eingeben",
      zipCode: (val: string) => (isDefined(val) ? null : "Bitte Wert eingeben"),
      city: (val: string) => (isDefined(val) ? null : "Bitte Wert eingeben"),
    },
  });

  const onSubmit = async () => {
    setLoading(true);
    const { values } = form;
    if (partner && (partner.firstName == null || partner.lastName == null)) {
        await ContactS.edit(partner.id, {firstName: values.partnerFirstName, lastName: values.partnerLastName}, profileId);
    }
    const resJSON = await ContactS.edit(id, {addressStreetAndNo : values.addressStreetAndNo, zipCode : values.zipCode, city : values.city, phoneNumber: values.phoneNumber}, profileId);
    setLoading(false);
    if (resJSON) {
      closeAllModals();
      onFinish(resJSON);
    }
  };

  const askPartnerName = partner && (!partner.firstName || !partner.lastName);

  return (
    <form onSubmit={form.onSubmit(onSubmit)}>
      <Text mb="md">
        Bitte vervollständige die folgenden Angaben, um {documentType == 'CONTRACT' ? 'den Vertrag' : 'das Angebot'} zu bestätigen:
      </Text>
      {askPartnerName && <TextInput required mt="sm" label="Partner Vorname" {...form.getInputProps("partnerFirstName")} />}
      {askPartnerName && <TextInput required mt="sm" label="Partner Nachname" {...form.getInputProps("partnerLastName")} />}
      <TextInput
        required
        mt="sm"
        label="Straße und Hausnummer"
        {...form.getInputProps("addressStreetAndNo")}
      />
      <TextInput required mt="sm" label="PLZ" {...form.getInputProps("zipCode")} />
      <TextInput required mt="sm" label="Stadt" {...form.getInputProps("city")} />
      <TextInput required mt="sm" label="Telefonnummer" {...form.getInputProps("phoneNumber")} />

        <Center mt={40}>
        <Button
          disabled={loading || !form.isDirty()}
          type="submit"
          rightIcon={loading && <Loader size="xs" />}
        >
          Speichern und {documentType == 'CONTRACT' ? 'Vertrag' : 'Angebot'} bestätigen
        </Button>
      </Center>
    </form>
  );
};
